'use strict'
import { request } from '../../plugins/http'

export default async (params, data) => {
    return await request.post('/anexoPedido', data, {params:params}, {headers:{"Content-Type": "multipart/form-data"}})
}